{
  "hero": {
    "title": "NAPAICP 評審操作手冊",
    "description": "從收到評審邀請到送出評分，完整說明評審在平台上的操作方式。內容只涵蓋目前平台實際已有的功能，畫面實際顯示為準。"
  },
  "quickNav": {
    "label": "頁內導覽",
    "overview": "適用對象",
    "account": "啟用評審帳號",
    "workspace": "評審工作區",
    "conflict": "利益衝突",
    "critical": "務必先看懂的規則",
    "scoring": "評分流程",
    "faq": "常見問題",
    "confidentiality": "保密與資料使用規則",
    "events": "活動"
  },
  "overview": {
    "heading": "適用對象",
    "description": "本手冊適用於受邀擔任評審的使用者。評審只能存取被指派的作品，且評審身分是「依競賽」授予的，同一人在不同競賽的評審身分是分開的。"
  },
  "account": {
    "heading": "啟用評審帳號",
    "steps": {
      "invite": {
        "title": "1. 收到評審邀請",
        "description": "主辦方會以 Email 寄送評審邀請；若您是新帳號，信件會附上一組僅供本人使用的臨時初始密碼。已有平台帳號者，信件只會請您登入；登入後在「總覽」頁的「待回覆的評審邀請」選擇「接受邀請」或「婉拒」（可填寫原因，主辦方會在邀請列表看到，並可再次邀請），接受後才會成為該競賽的評審。"
      },
      "activate": {
        "title": "2. 啟用 / 登入評審帳號",
        "description": "使用信件中的帳號與臨時初始密碼登入。臨時密碼有時效限制；登入成功後畫面會直接顯示「請設定您的新密碼」畫面（取代平台其餘內容），輸入至少 10 個字元的新密碼並送出即完成；完成前無法存取任何評審或競賽保護資料，畫面上僅頁首的帳號選單（含登出）仍可操作。送出成功後系統會自動載入正常畫面，不需要重新整理或重新登入。"
      },
      "existing": {
        "title": "3. 已有帳號的情況",
        "description": "若您原本就有平台帳號，不會產生臨時密碼：請以既有帳號登入，並在「總覽」頁的「待回覆的評審邀請」按「接受邀請」（或「婉拒」）。接受後才會成為該競賽的評審，並可從「前往評審任務」進入工作區；邀請的回覆期限為 7 天，逾期請主辦方重新邀請。"
      },
      "manageAccount": {
        "title": "4. 管理帳號與個資",
        "description": "在右上角帳號選單開啟「帳號與安全」，可修改密碼、變更 Email（需驗證目前密碼；變更需點擊寄送到新地址的驗證連結才會生效）、查看並登出已登入裝置。同一頁的「資料匯出與帳號刪除」區塊可下載一份平台持有您所有資料的 JSON 檔，或申請刪除帳號；申請送出後會排入平台管理員的審核佇列，經核准後您的識別資訊會被匿名化並永久刪除登入憑證，此操作無法復原。"
      }
    }
  },
  "workspace": {
    "heading": "進入評審工作區",
    "description": "登入後，前往評審區域即可看到目前指派給您的作品清單。清單只顯示指派給您、且未被利益衝突排除的作品；看不到其他評審的指派內容。",
    "steps": {
      "assignments": {
        "title": "1. 查看指派作品",
        "description": "指派清單會列出目前指派給您的所有作品（以匿名代碼呈現），每筆會顯示狀態徽章（未開始／草稿／已送出），上方也有待處理／草稿／已送出的統計與篩選按鈕。若該場競賽分為多輪，工作區會提供輪次頁籤可切換篩選；若您同時是多場競賽的評審，畫面上方會出現競賽選單，並顯示各競賽的待處理件數。清單頂端會顯示該輪的「審查截止」時間與剩餘時間（剩 72 小時內為黃色提醒，逾期為紅色並標示「已逾期」；這只是提醒，系統不會因逾期自動鎖定或關閉評分），並有整體完成進度條，未完成的作品會排在前面。首次進入某場競賽時，需先閱讀並勾選「評審須知與保密確認」（每場競賽只需一次；包含保密、利益迴避、匿名與公平、評分方式、截止時間五項）。點擊任一筆即可進入評分頁，評分頁標題下方會顯示所屬輪次與類別名稱，並可用「上一件／下一件」在同一輪的作品之間切換。若您無法擔任評審，清單下方的「無法擔任評審？退出本競賽評審」可填寫原因後取消您所有尚未送出評分的指派，已送出的評分不受影響，主辦方會看到原因並重新安排。主辦方新增指派後，系統會在最後一筆指派約 10 分鐘後寄出一封彙整的「新的評審指派」通知（不會每指派一次就寄一封）；主辦方重新開放您的分數時也會收到通知（信中不含主辦方填寫的原因）。清單上方的「我的評審資料」可自行維護服務單位、職稱、專長與簡介（主辦方在評審名單可見），「評分紀錄」可跨競賽查看已送出的分數，「公告」區塊顯示主辦方發給評審的最新公告。若主辦方把您的指派改派給別人或取消，約 10 分鐘後您會收到一封彙整的「評審指派已調整」通知（不含主辦方的原因），您已儲存的草稿不會被送出。退出時可勾選「同時放棄這場競賽的評審身分」，之後主辦方需重新邀請您；沒有任何指派的評審（例如剛以臨時密碼啟用的新帳號）也可以使用同一個連結放棄身分。"
      },
      "declareConflict": {
        "title": "2. 自行申報利益迴避",
        "description": "指派清單中每一筆作品旁都有「申報利益衝突」按鈕，點擊後填寫理由即可自行申報；申報成功後該筆作品會顯示「已申報迴避」徽章，原本的評分連結會被移除、無法再進入該作品的評分頁。"
      },
      "openWork": {
        "title": "3. 查看作品與附件",
        "description": "點擊指派項目進入評分頁。桌面版畫面為左右分欄：左側固定顯示作品說明與檔案的線上預覽，右側是評分表；可預覽的檔案以「線上預覽」為主要動作，下載為次要選項。若參賽者在繳交表單填了網址類欄位（例如「影片繳交網址」），左欄上方會出現「作品連結」區塊，列出欄位名稱與網址，點擊會在新分頁開啟；網址若是 YouTube 或 Vimeo，左欄會多出「簡報與檔案」｜「影片」兩個分頁，切換到「影片」即可在頁內直接播放，其他來源的影片只提供連結。每個連結下方會標示「外部連結」與網域；外部內容由參賽者控制、可能隨時變動，為保護匿名評審，建議以無痕視窗開啟。評審只會看到最終送出版本的網址，不會看到草稿。"
      }
    }
  },
  "conflict": {
    "heading": "利益衝突",
    "description": "利益衝突（COI）判定不是一個顯示在案件卡片上的獨立狀態欄位，而是系統在您每次操作時即時檢查的規則：只要判定成立，該案件就會從您可查看／可評分的清單中被排除，且伺服器端的送分與檔案存取 API 也會同步拒絕。",
    "sub": {
      "principle": {
        "heading": "利益衝突原則",
        "description": "只要您與某件作品的參賽者有可能影響評分公正性的關係（例如指導過該隊伍、有親屬或雇用關係），就必須申報利益迴避，不得繼續評分該件作品。是否構成衝突由您本人依實際關係判斷，系統不會自動偵測。"
      },
      "who": {
        "heading": "誰可以宣告利益衝突",
        "description": "除了您本人在指派清單中自行點擊「申報利益衝突」（自行宣告），具評審管理權限的主辦方／工作人員也可以在後台直接為您標記某件作品的利益衝突（不需要您本人操作）。兩種來源效果相同：一旦成立，該案件就會被排除在您可評分的範圍之外。"
      },
      "status": {
        "heading": "宣告後的案件狀態",
        "description": "利益衝突不是把案件本身的狀態改成某種特殊值，而是獨立紀錄的一筆迴避關係；系統每次查詢您的指派清單、每次送出分數、每次開啟作品檔案時都會即時檢查是否存在這筆紀錄，一旦存在就一律拒絕。因此該案件會持續從您的清單中消失，不會因為畫面重新整理或重新登入而恢復，除非該筆迴避紀錄被撤銷。"
      }
    }
  },
  "critical": {
    "heading": "務必先看懂的規則",
    "description": "以下規則直接關係到評分的公平性與合規性，請務必先讀過：",
    "items": {
      "onlyAssigned": "您只能看到並評分被指派給您的作品，無法瀏覽其他評審的指派內容。",
      "noSelfMatch": "系統不會、也不應該讓您自行把匿名代碼與參賽者真實身分對照；評審端本來就不會回傳不應揭露的參賽者身分資訊。",
      "conflictOfInterest": "若您與某件作品的參賽者有利益衝突（例如指導、親屬、雇用關係），不得繼續評分該件作品；您可以在指派清單中該筆作品旁點選「申報利益衝突」自行申報（見下方工作區步驟），申報後該作品即從您可評分的清單中移除。",
      "draftVsSubmit": "評分草稿與正式送出不同：草稿可以隨時修改，正式送出後分數會被鎖定，不能再自行修改。",
      "lockedAfterSubmit": "分數送出後會進入鎖定狀態，您本人無法自行解鎖；具權限的主辦方現在可以在該作品的投稿詳情頁自行點擊「重新開放」並填寫理由來重開，不需要再向平台管理端申請。",
      "noDownloadShare": "作品內容僅供評分使用，不得下載後轉傳、公開分享或用於評分以外的用途。"
    }
  },
  "scoring": {
    "heading": "評分流程",
    "steps": {
      "rubric": {
        "title": "1. 依評分規準（Rubric）評分",
        "description": "每個評分項目都有主辦方設定的允許範圍與說明；輸入超出範圍的分數，畫面會在送出前擋下並具名指出是哪一項超出範圍。若主辦方為評分項目寫了「分數級距範例」，點「查看評分說明」即可看到各分數區間的判斷標準。若作品標示「無需評分」，表示它已不在本次評比中，您的評分不會被計入，也不會再收到相關催審，已送出的評分不受影響；如有疑問請與主辦方聯絡。"
      },
      "comment": {
        "title": "2. 填寫評語",
        "description": "評分表分開提供兩個欄位：「個人評審備註」僅供您本人參考、絕不會顯示給主辦方；「審查意見」則是主辦方可以看到的評論。畫面上會清楚標示各欄位的可見範圍，請依用途填入正確欄位。"
      },
      "saveDraft": {
        "title": "3. 儲存草稿",
        "description": "尚未確定的評分可先儲存草稿，之後可以回來繼續修改，不會被視為正式送出。您停止輸入約 1.5 秒後系統會自動儲存草稿（狀態列會顯示「草稿 · 已儲存於 …」），離開頁面時也會先儲存；若有尚未儲存的內容而直接關閉分頁，瀏覽器會先詢問。草稿只會儲存您已填寫的評分項目，沒填的不會被當成 0 分。快捷鍵：Ctrl/⌘+S 儲存草稿、Ctrl/⌘+Enter 開啟送出確認（需全部填完）、Alt+←/→ 切換上一件／下一件。"
      },
      "checkComplete": {
        "title": "4. 確認完成度",
        "description": "評分表右上角會顯示目前完成度（已填寫項目數／總項目數）；所有項目都填寫完成前，「正式送出」按鈕會維持disabled狀態無法點擊，這是系統強制的門檻，不再只是提示。若該場競賽的主辦方已開啟「審查意見必填」設定，即使所有評分項目都已填寫完成，「正式送出」按鈕仍會維持disabled，直到「審查意見」欄位也填入內容為止；此設定依競賽個別開關，不代表所有競賽都要求填寫審查意見。"
      },
      "submit": {
        "title": "5. 正式送出評分",
        "description": "點擊「正式送出」後，畫面會先跳出確認對話框，列出總分與各評分項目的分數供最後核對；若「個人評審備註」欄位仍是空白，對話框會額外顯示提醒（不會擋下送出）。在對話框中再次確認後才會真正送出。送出成功會有明確的成功狀態顯示；送出後分數進入鎖定狀態，畫面會切換為唯讀的覆核模式，呈現總分、各項目加權後的貢獻，並提供前往下一件待處理作品的連結，個人評審備註區塊會持續標示「僅您本人可見」。"
      },
      "requestReopen": {
        "title": "6. 送出後如何申請修改",
        "description": "若送出後發現錯誤，請聯絡該場競賽的主辦方；具權限的主辦方現在可以直接在投稿詳情頁對已鎖定的分數點擊「重新開放」並填寫理由，不需要再另外向平台管理端申請，重開會產生對應的修改紀錄，不是悄悄改分數。"
      }
    }
  },
  "scoreLock": {
    "sub": {
      "immediate": {
        "heading": "送出即為鎖定，沒有中間的「已送出未鎖定」狀態",
        "description": "點擊「正式送出評分」的當下，分數會立即從草稿直接變成鎖定狀態，中間沒有另一個「已送出但尚未鎖定」的過渡狀態；換句話說，正式送出這個動作本身就是鎖定分數的動作，兩者是同一件事，不是先送出、再等待另一個步驟才鎖定。"
      },
      "reopened": {
        "heading": "重新開放後：狀態是「已重新開放」，不是退回草稿",
        "description": "具權限的主辦方／工作人員重新開放您已鎖定的分數後，該筆分數會顯示為「已重新開放」這個獨立狀態，而不是直接退回「草稿」；同時該作品會重新出現在您的待處理指派清單中，可以再次編輯。等您下一次儲存（不論是儲存草稿或再次正式送出），狀態才會依您的操作變回草稿或鎖定。重新開放的原因與修改前後的紀錄僅供主辦方與稽核使用，評審本人的畫面上不會顯示重新開放的原因文字。"
      }
    }
  },
  "faq": {
    "heading": "常見問題與錯誤排除",
    "items": {
      "noAssignment": {
        "q": "評審工作區沒有任何指派？",
        "a": "可能是主辦方尚未完成指派，或您與所有作品皆有利益衝突而被排除；請聯絡主辦方確認。"
      },
      "inviteExpired": {
        "q": "評審邀請信中的臨時密碼失效？",
        "a": "臨時初始密碼有時效限制；可在登入頁使用「忘記密碼」以註冊 Email 重設密碼，重設完成即可直接登入；或聯絡主辦方重新發送邀請以取得新的臨時密碼。"
      },
      "cannotPlayVideo": {
        "q": "影片分頁無法播放，或根本沒有「影片」分頁？",
        "a": "只有 YouTube 與 Vimeo 網址會出現「影片」分頁；其他來源（例如雲端硬碟）只會顯示在「作品連結」，請直接點連結開啟。若影片設為不公開或禁止嵌入，播放器可能顯示錯誤，同樣請改用「作品連結」開啟；仍無法觀看時請聯絡主辦方確認影片權限。"
      },
      "draftNotSaved": {
        "q": "草稿有存起來嗎？關掉分頁會不見嗎？",
        "a": "停止輸入約 1.5 秒後會自動儲存，狀態列顯示「草稿 · 已儲存於 …」就代表已存好；顯示「草稿 · 尚未儲存」時請稍候或按 Ctrl/⌘+S。若分數超出範圍，系統不會自動儲存，請先修正。只有您填寫過的評分項目會被儲存，沒填的項目不會被視為 0 分，所有項目填完才能正式送出。"
      },
      "withdraw": {
        "q": "我臨時無法擔任評審，可以退出嗎？",
        "a": "可以。在評審任務頁清單下方點「無法擔任評審？退出本競賽評審」，填寫原因後確認，您在該競賽所有尚未送出評分的指派會被取消，已送出的評分不受影響。這項操作您無法自行復原，主辦方會看到您的原因並重新安排；也可以先直接聯絡主辦方討論。"
      },
      "noAssignmentEmail": {
        "q": "主辦方指派作品後，為什麼沒有馬上收到通知信？",
        "a": "為避免主辦方連續指派時您收到一堆信，系統會在最後一筆指派後約 10 分鐘，把新增的指派彙整成一封信寄出；也可以直接登入評審任務頁查看。若作品被主辦方改派給別人或取消，約 10 分鐘後您會收到一封彙整的「評審指派已調整」通知，清單中該作品會消失，已儲存的草稿不會被送出。"
      },
      "declineInvitation": {
        "q": "收到評審邀請但無法擔任，要怎麼辦？",
        "a": "已有平台帳號：登入後在「總覽」頁的「待回覆的評審邀請」按「婉拒」，可填寫原因，主辦方會在邀請列表看到「已婉拒」與原因。新帳號（使用臨時密碼登入）：完成首次改密碼後您會成為評審；若無法擔任，請在評審任務頁按「無法擔任評審？退出本競賽評審」，勾選「同時放棄這場競賽的評審身分」（沒有任何指派也可以使用），或直接聯絡主辦方。"
      },
      "cannotOpen": {
        "q": "作品檔案無法開啟或下載？",
        "a": "請確認網路連線並重新整理頁面再試一次；若持續無法開啟，請聯絡主辦方協助確認檔案狀態。"
      },
      "outOfRange": {
        "q": "送出評分時顯示分數超出範圍？",
        "a": "畫面會具名指出哪一個評分項目超出允許範圍，請依該項目的說明調整分數後再送出。"
      },
      "requiredMissing": {
        "q": "可以送出還沒填完的評分表嗎？",
        "a": "不行。所有評分項目都填寫完成前，「正式送出」按鈕會維持disabled狀態，系統會直接擋下未完成的送出；請依評分表右上角的完成度提示逐項補齊。"
      },
      "afterSubmitChange": {
        "q": "送出後才發現評錯，怎麼辦？",
        "a": "評審本人無法自行修改已送出的分數；請聯絡主辦方，具權限的主辦方現在可以直接在投稿詳情頁對該筆分數點擊「重新開放」並填寫理由，不需要再另外向平台管理端申請。"
      },
      "announcementEmail": {
        "q": "我會收到主辦方的公告 Email 嗎？",
        "a": "可能會。主辦方可以把競賽公告以 Email 寄給評審，信件的主旨會以「公告｜」開頭，信末註明為競賽官方通知，並附上主辦單位的聯絡信箱；評審任務頁也會顯示主辦方發給評審的最新公告（最多 3 則），但不是每則公告都會寄信，請同時留意評審任務頁與信件。信中平台自動產生的連結都指向 aicp.ntpu.ai，平台不會在信中要求您提供密碼。若對信件有疑慮，請不要點信中的連結，改為直接開啟 https://aicp.ntpu.ai 登入確認，或寫信到信中的主辦單位聯絡信箱詢問。"
      }
    }
  },
  "confidentiality": {
    "heading": "保密與資料使用規則",
    "description": "您在評審過程中接觸到的作品內容與參賽者相關資訊，僅供本次評審使用，不得下載、轉傳、公開分享或用於評分以外的目的；評審身分與評分內容的存取範圍與稽核規則，請見 Trust Center 與隱私權說明。"
  },
  "cta": {
    "heading": "還有其他問題？",
    "howtoCta": "回到快速開始",
    "trustCta": "Trust Center"
  },
  "events": {
    "heading": "活動頁與評審身分",
    "description": "平台的活動頁（主導覽「活動」）與評審工作無關：評審身分是各競賽專屬，活動沒有評審角色，也不影響您的評分、指派或利益迴避。若您同時是活動與會者，可以像一般與會者使用活動服務。",
    "items": [
      {
        "title": "評審帳號可以使用活動服務",
        "description": "活動頁的接駁車預約、餐飲回覆與客服，只要登入並驗證 Email 即可使用，與您是否為某競賽評審無關。評審身分不會因此被修改。"
      },
      {
        "title": "免登入預約與評審帳號",
        "description": "接駁車的「只用 Email 預約」會以確認連結建立或沿用一般帳號。平台管理員等非一般使用者角色的帳號不能經由該連結登入，必須以一般登入方式進入。評審帳號仍以您原本的登入方式為準。"
      },
      {
        "title": "評審資料與活動資料分開",
        "description": "活動的乘車聯絡資料、餐飲備註不會顯示給競賽的評審或主辦方；競賽的評分、評語與指派資料也不會出現在活動頁。"
      }
    ],
    "links": [
      {
        "to": "/help/reference/events-overview",
        "label": "活動平台總覽"
      },
      {
        "to": "/events",
        "label": "前往活動"
      },
      {
        "to": "/help/student/book-event-shuttle",
        "label": "如何預約活動接駁車"
      }
    ]
  }
}
